export default __webpack_public_path__ + "static/media/Rastech-update-6-1.8193d575.jpg";